// User
export interface ScheduleSync_CoreUser {
    userId: string
    active: boolean
    externalId: string
    displayName: string
    emailAddress?: string
    hashedCivicNo?: string
    importTrackings?: ScheduleSync_CoreUserTrackingRef
    exportTrackings?: ScheduleSync_CoreUserTrackingRef[]
}

export interface ScheduleSync_CoreUserListing {
    userId: string
    active: boolean
    externalId: string
    displayName: string
    emailAddress?: string
    hashedCivicNo?: string
    eventCount: number
    hasParticipantRole: boolean
    hasOrganizerRole: boolean
}

export interface ScheduleSync_CoreUserTrackingRef {
    id: string
    active: boolean
    targetId: string
    targetSystem: string
    targetData?: string
    exported: string
}

export interface ScheduleSync_CoreEventRef {
    eventId: string
    active: boolean
    title?: string
    location?: string
    role?: string
    startTime: string
    endTime: string
}

export interface ScheduleSync_CoreTrackings {
    importTracking?: ScheduleSync_CoreUserTrackingRef
    exportTrackings?: ScheduleSync_CoreUserTrackingRef[]
}

export interface ScheduleSync_UserScheduleFilter {
    onlyActive: boolean
    weekDate: Date
}

export interface  ScheduleSync_UsersFilter {
    socialnumber?: string
    role?: string
    onlyActive?: boolean
    page?: number
    search?: string
}

// Event
export interface ScheduleSync_CoreEventListing {
    eventId: string
    active: boolean
    startTime: string
    endTime: string
    title: string
    location?: string
    numberOfOrganizers: number
    numberOfParticipants: number
    schoolName?: string
}

export interface ScheduleSync_CoreEvent {
    eventId: string
    active: boolean
    externalId: string
    startTime: string
    endTime: string
    title: string
    location?: string
    created: string
    lastModified: string
    inactivated?: string
    schoolName?: string
}

export interface ScheduleSync_CoreExportRef {
    id: string
    active: boolean
    exported: string
    exportedLastModified: string
    targetId: string
    targetSystem: string
    targetData?: string
    module?: {
        id: string
        title?: string
    }
}

export interface ScheduleSync_ListEventsFilter {
    onlyActive?: boolean
    page?: number
    onlyUpcomingDates?: boolean
    targetSystem?: ScheduleSyncExportSystem
}

enum ScheduleSyncExportSystem {
    invalid = 0,
    googleCalendar = 1,
    exchangeCalendar = 2,
    localAD = 3,
}

export const ScheduleSyncExportSystemOptions: ScheduleSyncExportSystem[] = [
    ScheduleSyncExportSystem.googleCalendar,
    ScheduleSyncExportSystem.exchangeCalendar,
    ScheduleSyncExportSystem.localAD,
]